module.exports = __webpack_public_path__ + "static/media/shopping_marina_marker.c78e046f.svg";